import { NgxsModuleOptions } from '@ngxs/store';
import { MeetingState } from '../../page/meetings/state/meeting.state';
import { RequestsState } from '../../page/requests/store/requests.state';
import { ApplicationConfig } from './application.config';
import { AuthState } from '../../shared/store/auth/auth.state';
import { ApplicationState } from '../../shared/store/application/application.state';
import { CacheDataState } from '../../shared/store/cache-data/cache-data.state';
import { NgxsStoragePluginOptions } from '@ngxs/storage-plugin';
import { MyPatientState } from '../../page/my-patient/store/my-patient.state';

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !ApplicationConfig.production,
  selectorOptions: {
    suppressErrors: false,
  },
  compatibility: {
    strictContentSecurityPolicy: true,
  },
};

export const ngxsStorageConfig: NgxsStoragePluginOptions = {
  namespace: ApplicationConfig.applicationName,
  keys: ['auth.token', 'auth.account'],
};

export const ngxsStates = [
  AuthState,
  ApplicationState,
  CacheDataState,
  MyPatientState,
  MeetingState,
  RequestsState
];
